import {copilotFeatureFlags} from '@github-ui/copilot-feature-flags'

type EmbeddedChatModule = typeof import('@github-ui/copilot-chat-app-next/EmbeddedChat')

let loadedModule: EmbeddedChatModule | undefined

export async function loadRewrittenEmbeddedChat() {
  loadedModule ??= await import('@github-ui/copilot-chat-app-next/EmbeddedChat')

  return loadedModule
}

export function loadedRewrittenEmbeddedChat() {
  return loadedModule?.EmbeddedChat
}

// Legacy's panel code is already loaded when the panel opens, so with the rewrite on its chat is loaded while the
// browser is idle instead of after the click.
export function preloadRewrittenEmbeddedChat() {
  if (!copilotFeatureFlags.chatSurfacesRewrite) return undefined

  const load = async () => {
    try {
      await loadRewrittenEmbeddedChat()
    } catch {
      // Opening the panel loads it again and reports any failure there.
    }
  }

  if (typeof requestIdleCallback !== 'function') {
    void load()

    return undefined
  }

  const idleCallback = requestIdleCallback(() => void load(), {timeout: 2000})

  return () => cancelIdleCallback(idleCallback)
}
